// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"22":"help","272":"maintenance","528":"reports","639":"categories","809":"users","920":"devices","945":"dashboard","962":"home"}[chunkId] + "." + {"22":"8f42be3b","272":"47cfba66","528":"fce1b312","639":"491bd221","809":"337ddf06","920":"9bcd3f99","945":"fd91718e","962":"e0c5c6d5"}[chunkId] + ".js";
};